import React, { useEffect, useState } from "react";
import { ragRecurring } from "../../service/ragSearch";
import RagRecurring from "./RagRecurring";

const TYPES = ["tanya", "hayomyom", "parsha"];

export default function DailyStudyWidget() {
  const [studies, setStudies] = useState({});

  useEffect(() => {
    let active = true;
    TYPES.forEach((type) => {
      ragRecurring(type)
        .then((data) => {
          if (active) setStudies((prev) => ({ ...prev, [type]: data }));
        })
        .catch(() => {
          /* hide sections that 404 / fail */
        });
    });
    return () => {
      active = false;
    };
  }, []);

  const available = TYPES.filter((t) => studies[t]);
  if (available.length === 0) return null;

  return (
    <div className="mb-10">
      <h2 className="text-[22px] md:text-2xl font-extrabold text-primaryDark mb-4">
        Today's Daily Study
      </h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {available.map((t) => (
          <RagRecurring key={t} recurring={studies[t]} />
        ))}
      </div>
    </div>
  );
}
